import { getErrorMessage } from '../../utils';
import {
  REQUEST_BOOKED_ENTERTAINMENTS,
  RECEIVE_BOOKED_ENTERTAINMENTS,
  SET_BOOKED_ENTERTAINMENTS_FAILURE,
  CLEAR_BOOKED_ENTERTAINMENTS_ERROR_MESSAGE,
  SET_SELECTED_NUM_OF_GUESTS,
} from '../constants/bookedEntertainments';

const initialState = {
  isFetching: false,
  wasCalled: false,
  entertainments: [],
  errorMessage: '',
  selectedNumOfGuests: 1,
};

const bookedEntertainmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_BOOKED_ENTERTAINMENTS: {
      return { ...state, isFetching: true };
    }
    case RECEIVE_BOOKED_ENTERTAINMENTS: {
      const { bookedEntertainments: entertainments } = action;
      return { ...state, isFetching: false, entertainments, wasCalled: true };
    }
    case SET_BOOKED_ENTERTAINMENTS_FAILURE: {
      const { error } = action;
      const errorMessage = getErrorMessage(error);
      return { ...state, isFetching: false, errorMessage, wasCalled: true };
    }
    case CLEAR_BOOKED_ENTERTAINMENTS_ERROR_MESSAGE: {
      return { ...state, errorMessage: '' };
    }
    case SET_SELECTED_NUM_OF_GUESTS: {
      const { selectedNumOfGuests } = action;
      return { ...state, selectedNumOfGuests: parseInt(selectedNumOfGuests, 10) };
    }
    default:
      return state;
  }
};

export default bookedEntertainmentsReducer;
